import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    link: {
      padding: [5, 16, 25],
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      fontWeight: 500,
      "&:hover": {
        "&::after": {
          display: "block",
          position: "absolute",
          content: "''",
          width: "100%",
          background: theme.palette.primary.main,
          height: "3px",
          bottom: "-16px",
        },
      },
      "&#ecards, &#ai-image-packs, & #button-invitations": {
        fontWeight: "bold",
        color: theme.palette.primary.main,
      },
      "&:first-child": {
        paddingLeft: 0,
      },
      "&:last-child": {
        paddingRight: 0,
      },
      [theme.breakpoints.up("tablet")]: {
        padding: 0,
        marginRight: 24,
        "&:last-child": {
          marginRight: 0,
        },
      },
    },
    activelink: {
      "&::after": {
        display: "block",
        position: "absolute",
        content: "''",
        width: "100%",
        background: theme.palette.primary.main,
        height: "3px",
        bottom: "-16px",
      },
    },
    subMenu: {
      position: "absolute",
      boxShadow: [0, 5, 5, "#00000030"],
      top: 44,
    },
  }),
  { name: "MenuItem" },
);
